import { apiAuth, apiResponseType } from ".";

export const getEmployeeDocuments = (employeeUuid: string): apiResponseType =>
  apiAuth.get(`employees/${employeeUuid}/documents`);

export const uploadEmployeeDocument = (
  employeeUuid: string,
  data: { name: string; file: File }
) =>
  apiAuth.postForm(`employees/${employeeUuid}/documents`, data) as apiResponseType;

export const deleteEmployeeDocument = (
  employeeUuid: string,
  documentUuid: string
) => apiAuth.delete(`employees/${employeeUuid}/documents/${documentUuid}`) as apiResponseType;

export const getEmployeeDocumentDownloadUrl = (
  employeeUuid: string,
  documentUuid: string
) =>
  apiAuth.get(
    `employees/${employeeUuid}/documents/${documentUuid}/download`
  ) as apiResponseType;
